import { motion } from "framer-motion";
import { IMAGES } from "@/lib/images";

export default function OutcomesBento({ content }) {
  const stats = content.stats || [];
  const [s0, s1, s2, s3] = [stats[0], stats[1], stats[2], stats[3]];

  const card = "bg-[#151821] border border-white/10 rounded-2xl p-8 relative overflow-hidden";
  const rise = (delay = 0) => ({
    initial: { opacity: 0, y: 28 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-60px" },
    transition: { duration: 0.7, delay },
  });

  return (
    <section id="impact" className="relative py-28 lg:py-36 grain" data-testid="impact-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p {...rise()} className="font-mono-tactical text-xs uppercase tracking-[0.25em] text-amber-500">
          Why It Matters
        </motion.p>
        <motion.h2
          {...rise(0.1)}
          className="mt-5 font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#F3F4F6] max-w-2xl"
          data-testid="impact-heading"
        >
          Recidivism is a mindset problem. Treat it like one.
        </motion.h2>

        <div className="mt-14 grid grid-cols-12 gap-5">
          <motion.div {...rise(0.1)} className={`${card} col-span-12 lg:col-span-8`} data-testid="bento-hero-stat">
            <div className="absolute -right-16 -bottom-16 w-64 h-64 rounded-full bg-amber-500/10 blur-[90px] pointer-events-none" />
            <div className="font-mono-tactical text-xs tracking-[0.2em] text-[#6B7280]">THE COST OF AN UNCHANGED MIND</div>
            <div className="mt-6 flex items-end gap-4 flex-wrap">
              <span className="font-display font-extrabold text-6xl sm:text-7xl lg:text-8xl text-amber-500 leading-none" data-testid="bento-stat-main">{s0?.value}</span>
              <p className="text-[#9CA3AF] text-sm sm:text-base max-w-sm pb-2 leading-relaxed">{s0?.label}</p>
            </div>
            <p className="mt-8 text-sm sm:text-base text-[#9CA3AF] max-w-xl leading-relaxed">
              Facilities don't fail for lack of rules — they struggle when nothing changes on the inside of the person.
              S2S targets the mindset that drives the return trip.
            </p>
          </motion.div>

          <motion.div {...rise(0.2)} className={`${card} col-span-12 sm:col-span-6 lg:col-span-4 flex flex-col justify-between`} data-testid="bento-stat-year-one">
            <div className="font-mono-tactical text-xs tracking-[0.2em] text-[#6B7280]">WITHIN YEAR ONE</div>
            <div className="mt-6 font-display font-extrabold text-5xl text-[#F3F4F6]">{s1?.value}</div>
            <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{s1?.label}</p>
          </motion.div>

          <motion.div {...rise(0.1)} className={`${card} col-span-12 sm:col-span-6 lg:col-span-4`} data-testid="bento-stat-cost">
            <div className="font-mono-tactical text-xs tracking-[0.2em] text-[#6B7280]">THE BUDGET LINE</div>
            <div className="mt-6 font-display font-extrabold text-5xl text-[#F3F4F6]">{s2?.value}</div>
            <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{s2?.label}</p>
          </motion.div>

          <motion.div {...rise(0.2)} className={`${card} col-span-12 sm:col-span-6 lg:col-span-4 border-amber-500/30`} data-testid="bento-stat-mindset">
            <div className="font-mono-tactical text-xs tracking-[0.2em] text-amber-500">THE MULTIPLIER</div>
            <div className="mt-6 font-display font-extrabold text-5xl text-amber-500">{s3?.value}</div>
            <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{s3?.label}</p>
          </motion.div>

          <motion.div {...rise(0.3)} className={`${card} col-span-12 lg:col-span-4 !p-0`} data-testid="bento-image-card">
            <img src={IMAGES.journalReading} alt="Resident journaling during an S2S workshop" className="w-full h-full object-cover min-h-[220px] grayscale-[30%]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D0E11]/90 to-transparent" />
            <div className="absolute bottom-5 left-6 right-6 font-mono-tactical text-[11px] tracking-[0.2em] text-[#F3F4F6]/80">
              WRITTEN EXERCISES — EVERY MODULE
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
